import { render } from "./PackageOrderGeneratorAssistantModal.vue?vue&type=template&id=4900ddf1&scoped=true"
import script from "./PackageOrderGeneratorAssistantModal.vue?vue&type=script&lang=js"
export * from "./PackageOrderGeneratorAssistantModal.vue?vue&type=script&lang=js"

import "./PackageOrderGeneratorAssistantModal.vue?vue&type=style&index=0&id=4900ddf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900ddf1"]])

export default __exports__